"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "colli-verdi": {
    "carmine": [{
      "hkey": "199121a4",
      "slug": "carmine-ruino-centro",
      "name": "Carmine-Ruino Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "ruino"
    }],
    "e39850c0": [{
      "hkey": "7f486709",
      "slug": "canavera",
      "name": "Canavera",
      "primary": true,
      "skipSearch": false
    }],
    "canavera": [{
      "hkey": "7f486709",
      "slug": "canavera",
      "name": "Canavera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "ruino"
    }],
    "71fd19ae": [{
      "hkey": "199121a4",
      "slug": "carmine-ruino-centro",
      "name": "Carmine-Ruino Centro",
      "primary": true,
      "skipSearch": false
    }],
    "29bcd691": [{
      "hkey": "5a08eaef",
      "slug": "ca-vannone",
      "name": "Ca' Vannone",
      "primary": true,
      "skipSearch": false
    }],
    "casa-vannone": [{
      "hkey": "5a08eaef",
      "slug": "ca-vannone",
      "name": "Ca' Vannone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "ruino"
    }],
    "5bface1b": [{
      "hkey": "bac962f3",
      "slug": "canevino",
      "name": "Canevino",
      "primary": true,
      "skipSearch": false
    }],
    "caseo": [{
      "hkey": "bac962f3",
      "slug": "canevino",
      "name": "Canevino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fa2ac0ca": [{
      "hkey": "bb0b6748",
      "slug": "pometo",
      "name": "Pometo",
      "primary": true,
      "skipSearch": false
    }],
    "pometo": [{
      "hkey": "bb0b6748",
      "slug": "pometo",
      "name": "Pometo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "ruino"
    }],
    "efbcd604": [{
      "hkey": "7af3b07f",
      "slug": "torre-degli-alberi",
      "name": "Torre degli Alberi",
      "primary": true,
      "skipSearch": false
    }],
    "torre-degli-alberi": [{
      "hkey": "7af3b07f",
      "slug": "torre-degli-alberi",
      "name": "Torre degli Alberi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "ruino"
    }]
  }
};
exports["default"] = _default;